export { LoyaltyHomeHowItWorks } from './LoyaltyHomeHowItWorks';
